import React, { Component } from "react";
import { auth } from "../../firebase/index";
import { customLog } from "../../variables/Variables";

class AddToGroupLock extends Component {
  constructor(props) {
    super(props);

    this.addLockToGroup = this.addLockToGroup.bind(this);

    this.state = {
      selectedLock: [],
    };
  }

  addLockToGroup() {
    customLog(this.props.data);
    const data = this.props.data;
    const { dataCallBack } = this.props;

    const lockDetails = {
      lockId: data.id,
      Name: data.Name,
      Password: data.Password,
      Type: data.Type,
      ip45SerialNumber: data.ip45SerialNumber,
      // uid: data.uid,
    };
    this.setState(
      {
        lockDetails: [lockDetails],
      },
      () => {
        dataCallBack(this.state.lockDetails);
      }
    );
  }
  render() {
    // console.log(this.props);
    return (
      <div>
        <button
          className={"select-btn"}
          // disabled={
          //   this.props.data.isSuperAdmin ||
          // this.props.data.memberEmail === auth.currentUser.email
          // }
          onClick={this.addLockToGroup}
        >
          &#43;
        </button>
      </div>
    );
  }
}

export default AddToGroupLock;
